<template>
  <div :style="{ width }">
    <ValidationProvider v-slot="{ errors }" :rules="rules" :name="label" :vid="name" :disabled="disabledStatus">
      <fragment v-if="localValue &&
       ( typeof (localValue) === 'string' || localValue instanceof String ) && localValue.includes('https://')">
        <CImg
                :src="localValue.fileName || localValue"
                block
                class="col-sm-2"
                style="max-width: 100px"
        />
      </fragment>
      <fragment v-else-if="thumbnail">
        <CImg
                :src="thumbnail"
                block
                class="col-sm-2"
                style="max-width: 100px"
        />
      </fragment>
      <fragment v-else-if="localValue['fileName']">
        <div style="margin-top: 20px">{{ localValue['fileName'] }}</div>
      </fragment>
      <fragment v-else>
      <v-file-input
        class="file-field"
        :error-messages="errors[0]"
        :name="name"
        :loading="uploading"
        @change="onFileChanged"
        :placeholder="localValue ? localValue : ''"
        @click:clear="onRemove"
        :accept="accept"
        chips
        prepend-icon="mdi-camera"
      >
        <!-- :placeholder="storedFile" -->
      </v-file-input>
      </fragment>
    </ValidationProvider>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  props: {
    value: {
    },
    name: {
      type: String
    },
    label: {
      type: String
    },
    rules: {
      type: [String, Object],
      default: ""
    },
    errorMessages: {
      type: Array
    },
    // TODO: 削除検討
    displayStoredFile: {
      type: Boolean,
      default: false
    },
    storedFile: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "300px"
    },
    accept: {
      type: String,
      default: "image/*"
    },
    thumbnail: {
      type: String,
      default: null
    },
    updateThumbnail: {
      type: Function,
      default: () => {

      }
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      uploading: false,
      fileName: "",
      fileTempUrl: null
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    disabledStatus() {
      if (this.localValue && ( typeof (this.localValue) === 'string' || this.localValue instanceof String ) && this.localValue.includes('https://') || this.localValue['fileName']){
        return true;
      }

      return false;
    }
  },
  methods: {
    onFileChanged(file) {
      if (file) {
        this.uploading = true;
        let formData = new FormData();
        formData.append("file", file);

        axios
          .postUpload("file", formData)
          .then(response => {
            if (response.data) {
              this.localValue =
                response.data.data
              ;
              this.fileName = response.data.data["fileName"];
            }
            this.uploading = false;

            this.updateThumbnail(this.index, file);
            this.fileTempUrl = URL.createObjectURL(file);
          })
          .catch(() => {
            this.uploading = false;
            this.fileTempUrl = null;
          });
      }
    },
    onRemove() {
      this.fileName = "";
      this.localValue = "";
      this.fileTempUrl = null;

      // this.$refs.hidden.value = "";

      // this.$nextTick().then(() => {
      //   this.$validator.validate(this.name);
      // });
    }
  }
};
</script>

<style module lang="scss"></style>
